import React, { memo } from "react"

import truncate from "lodash/truncate"
import PropTypes from "prop-types"
import { View, Text } from "react-native"

import { MAX_NAME_LENGHT } from "contexts/TeeupPreviewContext/constants"

import styles from "./messageSenderStyles"

const MessageSender = ({ name, isAttachment, timestamp }) => (
  <View style={isAttachment && styles.attachmentSender}>
    <View style={styles.senderRow}>
      <Text style={styles.messageSenderText}>
        @{truncate(name, { length: MAX_NAME_LENGHT })}
      </Text>
      {!!timestamp && (
        <Text
          numberOfLines={1}
          style={styles.messageSenderTimestamp}
          testID="messageTimestamp">
          {timestamp}
        </Text>
      )}
    </View>
  </View>
)

MessageSender.propTypes = {
  name: PropTypes.string,
  isAttachment: PropTypes.bool.isRequired,
  timestamp: PropTypes.string,
}

export default memo(MessageSender)
